import '@/App.css';
import SmoothScroll from '@/components/SmoothScroll';
import Navbar from '@/components/Navbar';
import Hero from '@/components/sections/Hero';
import Process from '@/components/sections/Process';
import About from '@/components/sections/About';
import Faq from '@/components/sections/Faq';
import Footer from '@/components/sections/Footer';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <SmoothScroll>
      <div className="App relative bg-[#0d0d0d]">
        <Navbar />
        <main>
          <Hero />
          <Process />
          <About />
          <Faq />
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </div>
    </SmoothScroll>
  );
}

export default App;
